const MOTIVOS_DESCRIPCION_OBLIGATORIA = new Set(['08', '09', '13']);

const normalizeText = (value) => String(value ?? '').trim();

export function motivoRequiereDescripcion(motivo) {
  return MOTIVOS_DESCRIPCION_OBLIGATORIA.has(normalizeText(motivo));
}

export function esTransportePublico(tipoGuia, tipoTransporte) {
  if (normalizeText(tipoGuia) === '31') return true;
  const tipo = normalizeText(tipoTransporte).toLowerCase();
  return tipo === 'publico' || tipo === 'publico';
}

export function requiereVehiculoChofer(tipoGuia, tipoTransporte) {
  if (normalizeText(tipoGuia) === '31') return true;
  return normalizeText(tipoTransporte).toLowerCase() === 'privado';
}

export function validateGuiaForm(form, detalles) {
  const tipoGuia = normalizeText(form?.tipo_guia || '09');
  const esGuiaTransportista = tipoGuia === '31';
  const requiereTransportista = esTransportePublico(tipoGuia, form?.tipo_transporte);
  const requiereDatosVehiculoChofer = requiereVehiculoChofer(tipoGuia, form?.tipo_transporte);
  const items = Array.isArray(detalles) ? detalles : [];

  if (!normalizeText(form?.serie)) return 'La serie es requerida';
  if (!normalizeText(form?.fecha_emision)) return 'La fecha de emision es requerida';
  if (!normalizeText(form?.fecha_inicio_traslado)) return 'La fecha de inicio de traslado es requerida';
  if (!normalizeText(form?.motivo_traslado)) return 'El motivo de traslado es requerido';
  if (motivoRequiereDescripcion(form?.motivo_traslado) && !normalizeText(form?.descripcion_motivo)) {
    return 'La descripcion del motivo es requerida para este motivo de traslado';
  }
  if (!(Number(form?.peso_bruto_total) > 0)) return 'El peso bruto total debe ser mayor a 0';
  if (!normalizeText(form?.punto_partida_ubigeo)) return 'El ubigeo del punto de partida es requerido';
  if (!normalizeText(form?.punto_partida_direccion)) return 'La direccion del punto de partida es requerida';
  if (!normalizeText(form?.punto_llegada_ubigeo)) return 'El ubigeo del punto de llegada es requerido';
  if (!normalizeText(form?.punto_llegada_direccion)) return 'La direccion del punto de llegada es requerida';
  if (normalizeText(form?.motivo_traslado) === '04' && !normalizeText(form?.punto_partida_almacen_id)) {
    return 'Para motivo 04 debe seleccionar el almacen de origen';
  }
  if (normalizeText(form?.motivo_traslado) === '04' && !normalizeText(form?.punto_llegada_almacen_id)) {
    return 'Para motivo 04 debe seleccionar el almacen de destino';
  }
  // Traslado entre establecimientos (04): es UN solo movimiento entre dos
  // almacenes puntuales — todas las lineas del detalle deben pertenecer al
  // mismo almacen, y ese almacen debe coincidir con el punto de partida de
  // la cabecera (el kardex siempre usa el de cabecera para este motivo, asi
  // que un almacen distinto en el detalle produce un traslado incorrecto).
  if (normalizeText(form?.motivo_traslado) === '04') {
    const almacenesUsados = new Set(
      items.map(d => normalizeText(d?.almacen_id)).filter(v => v !== '')
    );
    if (almacenesUsados.size > 1) {
      return 'El detalle tiene productos de distintos almacenes. Para traslado entre establecimientos (motivo 04), todas las lineas deben ser del mismo almacen.';
    }
    const almacenPartida = normalizeText(form?.punto_partida_almacen_id);
    const [almacenDetalle] = almacenesUsados;
    if (almacenDetalle && almacenPartida && almacenDetalle !== almacenPartida) {
      return 'El almacen del detalle no coincide con el punto de partida de la cabecera. Para traslado entre establecimientos (motivo 04), deben ser el mismo almacen.';
    }
  }
  if (!normalizeText(form?.destinatario_numero_doc)) return 'El documento del destinatario es requerido';
  if (!normalizeText(form?.destinatario_razon_social)) return 'La razon social o nombre del destinatario es requerida';
  if (items.length === 0) return 'Debe agregar al menos un item';

  if (requiereTransportista && !normalizeText(form?.transportista_ruc)) {
    return 'El RUC del transportista es requerido para este tipo de guia';
  }
  if (requiereTransportista && !normalizeText(form?.transportista_razon_social)) {
    return 'La razon social del transportista es requerida';
  }
  // registro_mtc es informativo (no viaja en el XML enviado a SUNAT) — opcional.

  // Vehículos tipo M1/L están exentos de datos de chofer (SUNAT Catálogo 33)
  const exentoChofer = form?.vehiculo_exento_chofer === true;

  if (requiereDatosVehiculoChofer && !normalizeText(form?.vehiculo_placa)) {
    return 'La placa del vehiculo es requerida';
  }
  if (requiereDatosVehiculoChofer && !exentoChofer && !normalizeText(form?.chofer_numero_doc)) {
    return 'El documento del chofer es requerido';
  }
  if (requiereDatosVehiculoChofer && !exentoChofer && !normalizeText(form?.chofer_nombres)) {
    return 'El nombre del chofer es requerido';
  }
  if (requiereDatosVehiculoChofer && !exentoChofer && !normalizeText(form?.chofer_licencia)) {
    return 'La licencia del chofer es requerido';
  }

  if (esGuiaTransportista && !normalizeText(form?.remitente_numero_doc)) {
    return 'El documento del remitente es requerido para la guia transportista';
  }
  if (esGuiaTransportista && !normalizeText(form?.remitente_razon_social)) {
    return 'La razon social o nombre del remitente es requerida para la guia transportista';
  }
  if (esGuiaTransportista && normalizeText(form?.pagador_flete) === 'otro_tercero') {
    if (!normalizeText(form?.tercero_numero_doc)) return 'Debe indicar el documento del tercero pagador del flete';
    if (!normalizeText(form?.tercero_razon_social)) return 'Debe indicar la razon social del tercero pagador del flete';
  }

  return null;
}